import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import SvgUpArrowIcon from '../../svg/UpArrowIcon';


let ToolsInfo = [
  {
    name: 'ASCII Field Converter',
    link: '/support/db/asciirepair',
    description: 'Convert non-ascii fields to ascii',
    fmtId: "db.asciiRepairToolLinkText",
  },
  {
    name: 'Foreign Key Repair',
    link: '/support/db/fkrepair',
    description: 'Repair foreign key constraints',
    fmtId: "db.fkRepairToolLinkText",
  },
  {
    name: 'Query Catalog',
    link: '/support/db/query',
    description: 'Run general queries',
    fmtId: "db.QueryToolLinkText",
  },
]


function Db() {
  const backText = (
    <FormattedMessage
      id="db.backText"
      defaultMessage="Back to Support Tools"
      description="Link back to Support Tools "
    />
  );
  return (
    <div className="container">
      <div className="layout-container content-container content-container--column content-container--shadow">
        <div className="width-100 align-center flex-around margin-bottom-10">
          <Link
            className="link-text align-center"
            to="/support/"
            data-test="db-back-link">
            <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
            {backText}
          </Link>
        </div>

        <div className="content-display__container content-display__container--column align-center">
          <FormattedMessage
            id="db.header"
            data-test="db-header-text"
            defaultMessage="Database Tools"
            description="The title for the page">
            {(txt) => (
              <h1
                className="no-margin text-deep-blue text-center"
                data-test="header-text-device">
                {txt}
              </h1>
            )}
          </FormattedMessage>
          <hr />

          <div
            className="content-display__container"
            data-test="content-container">
            <div
              className="content-display__column content-display__column--1-2"
              data-test="active-unit-container">
              <div className="content-display__item-pill-container">
                <div className="item-container__info-container item-container__main-text">
                  <ul className="no-margin list-no-bullets">
                    <li>
                      <Link to="/support/db/asciirepair" className="link-text">
                        <FormattedMessage id="db.asciiRepairToolLinkText" defaultMessage="ASCII Field Converter" description="Convert non-ascii fields to ascii"/>
                      </Link>
                    </li>
                    <li>
                      <Link to="/support/db/fkrepair" className="link-text">
                        <FormattedMessage id="db.fkRepairToolLinkText" defaultMessage="Foreign Key Repair" description="Repair foreign key constraints"/>
                      </Link>
                    </li>
                    <li>
                      <Link to="/support/db/query" className="link-text">
                        <FormattedMessage id="db.QueryToolLinkText" defaultMessage="Query Catalog" description="Run general queries"/>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="width-100 align-center flex-around margin-bottom-10">
            <Link
              className="link-text align-center"
              to="/support/"
              data-test="user-display-cancel-link">
              <SvgUpArrowIcon className="rotate-90-ccw margin-right-10" />
              {backText}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Db;
